import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SearchForm from '../components/search/SearchForm';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import TFFlamingo from '../assets/TF-sun-icon.png';
import ResultsGrid from '../components/results/ResultsGrid';

function HomePage() {
  const [showResults, setShowResults] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setShowResults(location.pathname === '/results');
  }, [location]);

  const handleSearch = () => {
    setShowResults(true);
    navigate('/results');
  };

  useEffect(() => {
    if (location.pathname === '/') {
      setShowResults(false);
    }
  }, [location.pathname]);

  return (
    <div className="App">
      <Header />
      
      <main className="main-content">
        <div className="search-container">
          <SearchForm onSearch={handleSearch} />
        </div>

        {showResults ? (
          <ResultsGrid />
        ) : (
          <div className="robot-container">
            <img 
              src={TFFlamingo} 
              alt="TravelFind Assistant" 
            />
          </div>
        )}
      </main>
      
      <Footer />
    </div>
  );
}

export default HomePage;